module.exports = __webpack_public_path__ + "static/media/IBM_Call_v2.b3d844dd.png";